var map = {
	"./de-BE.json": 98476,
	"./en-GB.json": 64168,
	"./fr-BE.json": 28309,
	"./hi-IN.json": 45614,
	"./mr-IN.json": 82066,
	"./nl-BE.json": 48215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88465;